function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTailArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 8",
    style: {
      enableBackground: "new 0 0 13 8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "m6.5 6.3 5.2-6c.2-.3.6-.4.9-.2l.1.1c.3.2.3.7.1 1L7.1 7.8c-.1.1-.4.2-.6.2-.3 0-.5-.1-.7-.2L.2 1.2C-.1.9 0 .5.3.2c.3-.3.7-.2.9.1"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTailArrowDown);
export default __webpack_public_path__ + "static/media/no-tail-arrow-down.bc7b10e07e3a908c585d048412f929d0.svg";
export { ForwardRef as ReactComponent };